<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("daily_attendance.attendance_detail") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="flex justify-between w-full mt-6">
          <Box
            v-for="(item, index) in percentStudent"
            :key="index + item.name"
            :numberOfStudent="item.number_student"
            :isPercent="item.isPercent"
            :percentTxt="item.percent_student"
            :title="item.name"
          ></Box>
        </div>
        <div class="w-full mt-6" v-if="Object.keys(detail).length">
          <md-table class="w-full overflow-auto">
            <md-table-row>
              <md-table-head class="w-1/3">
                <span class="text-left text-[#333] font-medium">{{
                  $t("common.student")
                }}</span>
              </md-table-head>
              <md-table-head class="w-1/3">
                <span class="text-left text-[#333] font-medium">{{
                  $t("common.status")
                }}</span>
              </md-table-head>
              <md-table-head>
                <span class="text-left text-[#333] font-medium">{{
                  $t("smi_sri.comment")
                }}</span>
              </md-table-head>
            </md-table-row>
            <md-table-row
              v-for="(item, index) in detail"
              :key="index + 'meta_data'"
            >
              <md-table-cell class="border-none p-0" colspan="3">
                <md-list class="py-[3px]">
                  <md-list-item
                    md-expand
                    class="bg-[#EEEEEE] cursor-pointer rounded-lg"
                  >
                    <div class="  flex justify-between items-center  w-full">
                      <div>
                        <div class="flex w-full pb-1 font-medium">
                          <div class="pr-2">
                            {{ moment(item.date).format(formatDateClient) }}
                          </div>
                          <div>
                            - {{ item.present_student }}/{{
                              item.total_student
                            }}
                          </div>
                        </div>
                        <div class="whitespace-normal">
                          {{ item.comment }}
                        </div>
                      </div>
                    </div>
                    <md-list slot="md-expand">
                      <md-list-item class="md-inset">
                        <md-table class="w-full">
                          <md-table-row
                            v-for="(attendance, index) in item.attendance"
                            :key="index + 'user_id'"
                          >
                            <md-table-cell class="w-1/3">
                              <div class="flex items-center gap-2">
                                <img
                                  class="rounded-full mr-4 w-12 h-12"
                                  :src="
                                    attendance.user_no_sql.avatar_url ||
                                      '/img/avt_placeholder.jpg'
                                  "
                                  alt="Avatar"
                                />
                                <p class="text-sm text-[#333] w-max">
                                  {{ attendance.user_no_sql.full_name }}
                                </p>
                              </div>
                            </md-table-cell>
                            <md-table-cell class="py-1 w-1/3">
                              <div
                                :style="{
                                  'background-color': setBgColorAttendanceStatus(
                                    attendance.status
                                  )
                                }"
                                class="status-cell w-1/2 py-2"
                              >
                                <span
                                  :style="{
                                    color: setColorAttendanceStatus(
                                      attendance.status
                                    ),
                                    'font-weight': 'bold'
                                  }"
                                >
                                  {{ generateStatus(attendance.status) }}
                                </span>
                              </div></md-table-cell
                            >
                            <md-table-cell
                              class="whitespace-normal break-normal py-1 w-1/3"
                            >
                              {{ attendance.description }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table></md-list-item
                      >
                    </md-list>
                  </md-list-item>
                </md-list>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <div v-else class="flex justify-center items-center w-full my-4">
          <no-data-found></no-data-found>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import Box from "./Box.vue";
import { generateStatus } from "@/helpers/text-helper";
import {
  setColorAttendanceStatus,
  setBgColorAttendanceStatus
} from "../../../../helpers/color";
import { formatDateClient } from "@/helpers/datetime-helper";
import moment from "moment";

export default {
  props: ["percentStudent", "detail"],
  components: {
    Box
  },
  data() {
    return {
      setColorAttendanceStatus,
      setBgColorAttendanceStatus,
      generateStatus,
      formatDateClient,
      moment
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.status-cell {
  text-align: center;
  padding: 4px 8px;
  border-radius: 16px;
}
::v-deep .md-inset .md-list-item-container .md-ripple {
  padding: 0;
}
.md-list-item-expand {
  border-top: none;
  border-bottom: none;
}
tbody .md-table-row:first-child td {
  border-top: none;
}
</style>
